import { peekOutbox } from "./db";

// #1902 — the support-only "flush outbox and rebuild local data" recovery
// button's orchestration, kept apart from the component so it can be unit
// tested against the real outbox/db without rendering React.
//
// Order (AC3/AC4 of #1902):
//   1. Stop the engine's own periodic timers first, so nothing else touches
//      the outbox or the database while this runs (the periodic flush would
//      otherwise race the check below or the wipe itself).
//   2. Force one flush and wait for it to drain everything it can.
//   3. Re-peek the outbox. If ANYTHING is still queued (offline, a
//      backoff-scheduled retry, a held op from another sub, or a permanent
//      "terminal" failure) that is unsynced work — abort before the wipe,
//      delete nothing, tell the caller.
//   4. Only on a genuinely empty outbox: wipe the database and re-hydrate.
//
// `syncEngine` and `rebuildDb` are passed in (not imported as the app-wide
// singleton) so a test exercises this exact call site against a fake engine
// and a fake db, per #1902 AC5.
export async function flushAndRebuildLocalData({ syncEngine, rebuildDb }) {
  syncEngine.stop();
  try {
    await syncEngine.flush();
    const remaining = await peekOutbox();
    if (remaining.length > 0) {
      return { ok: false, remaining: remaining.length };
    }
    await rebuildDb();
    await syncEngine.hydrate();
    return { ok: true };
  } finally {
    syncEngine.start();
  }
}
